import { StaticImage } from "gatsby-plugin-image";
import React from "react";

const SocialLinks = () => {
  return (
    <ul className="flex gap-x-3">
      <li className="w-6 h-6">
        <a href="https://www.facebook.com/profile.php?id=100063726275917" target="_blank">
          <StaticImage
            className="max-h-20 ml-auto fill-red-200"
            src="../../images/facebook-white.png"
            alt="Facebook"
          />
        </a>
      </li>
      <li className="h-6">
        <a href="https://www.youtube.com/channel/UCw23j9MJchQjHg2YV15ktkg" target="_blank">
          <StaticImage
            className="max-h-20 ml-auto fill-red-200"
            src="../../images/youtube-white.png"
            alt="YouTube"
          />
        </a>
      </li>
      <li className="w-6 h-6">
        <a href="https://www.instagram.com/rapatacsandviken/" target="_blank">
          <StaticImage
            className="max-h-20 ml-auto fill-red-200"
            src="../../images/instagram-white.png"
            alt="Instagram"
          />
        </a>
      </li>
    </ul>
  );
};

export default SocialLinks;
